import { events } from '@otto-ec/global-resources/event-q-bus';
import type { Topics } from '@shared/eventBus/eventQBus.types.ts';
import type { EventsOutgoing } from '@tilelist/application/ports/EventsOutgoing.ts';
import type { TileListLoadedPayload } from '@tilelist/application/ports/TileListLoaded.ts';

type TileListLoadedPublisher = {
    emit(payload: TileListLoadedPayload): unknown[];
};

/**
 *
 *
 */
export function createEventsOutgoing(tileListLoaded: TileListLoadedPublisher): EventsOutgoing {
    const bus = events<Topics>();

    return {
        publishTileListLoaded(payload) {
            tileListLoaded.emit(payload);
        },
        requestPageResolution(event) {
            bus.emit('ftfind.dresonRule.resolve', event);
        },
        /*                           */
        pushHistoryCheckpoint(event) {
            bus.emit('ftfind.history.push', event);
        },
        /*                           */
        seedHistoryState(event) {
            bus.emit('ftfind.history.merge', event);
        },
        notifyComparisonOpened() {
            bus.emit('reptile.comparison.opened');
        },
        notifyComparisonClosed() {
            bus.emit('reptile.comparison.closed');
        },
    };
}
